/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'nav/sidebar/warehouse-certificate': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" _stroke="currentColor" d="M2.5 2.5h17v17h-17zM5 6h12M5 9h12M5 12h6"/><circle pid="1" cx="14.5" cy="14.5" r="2" _stroke="currentColor"/>'
  }
})
